import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { NgComponentOutlet } from '@angular/common';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ModalService } from '../../services/modal-service';
import { Tooltip } from '../../directives/tooltip.directive';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-content-modal',
  standalone: true,
  imports: [TranslateModule, NgComponentOutlet, IconComponent, Tooltip],
  templateUrl: './content-modal.html',
  styleUrl: './content-modal.scss',
  host: {
    '(mousedown)': 'onHostMouseDown($event)',
    '(click)': 'onHostClick($event)',
  },
})
export class ContentModal {
  data = inject(DIALOG_DATA) as {
    component: ComponentType<unknown>;
    title?: string;
    inputs?: Record<string, any>;
    outputs?: Record<string, (value: any) => void>;
  };
  component = this.data.component;
  public modalService: ModalService = inject(ModalService);
  title: string | undefined = this.data.title;

  outlet = viewChild(NgComponentOutlet);

  private host: ElementRef<HTMLElement> = inject(ElementRef);
  private pressStartedOnMargin = false;

  onHostMouseDown(event: MouseEvent): void {
    this.pressStartedOnMargin = event.target === this.host.nativeElement;
  }

  onHostClick(event: MouseEvent): void {
    if (this.pressStartedOnMargin && event.target === this.host.nativeElement) {
      this.modalService.closeModal();
    }
    this.pressStartedOnMargin = false;
  }

  ngAfterViewInit(): void {
    const componentInstance = this.outlet()?.componentInstance;
    if (!this.data.outputs || !componentInstance) return;
    for (const [key, handler] of Object.entries(this.data.outputs)) {
      const output = (componentInstance as any)[key];
      if (output && typeof output.subscribe === 'function') {
        output.subscribe(handler);
      }
    }
  }
}
